<ds-item-search-result-list-element [useGcWeb]="useGcWeb" [showLabel]="showLabel" [object]="{ indexableObject: object, hitHighlights: {} }" [linkType]="linkType"></ds-item-search-result-list-element>
